import React from "react";
import {
  BarChart,
  Bar,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer,
} from "recharts";
import "./commission.css";
import ProfileHeader from "../profile/components/ProfileHeader";
import { useOutletContext } from "react-router-dom";

const data = [
  { month: "Jan", target: 250, completed: 220, commission: 44000 },
  { month: "Feb", target: 300, completed: 260, commission: 52000 },
  { month: "Mar", target: 280, completed: 200, commission: 40000 },
  { month: "Apr", target: 260, completed: 230, commission: 46000 },
  { month: "May", target: 310, completed: 290, commission: 58000 },
  { month: "Jun", target: 270, completed: 250, commission: 50000 },
  { month: "Jul", target: 320, completed: 300, commission: 60000 },
  { month: "Aug", target: 290, completed: 240, commission: 48000 },
  { month: "Sep", target: 260, completed: 210, commission: 42000 },
  { month: "Oct", target: 300, completed: 280, commission: 56000 },
  { month: "Nov", target: 310, completed: 295, commission: 59000 },
  { month: "Dec", target: 330, completed: 310, commission: 62000 },
];


const Commission = () => {
  const totalTarget = 300;
  const totalCompleted = 260;
  const commissionRate = 200;
  const estimatedCommission = totalCompleted * commissionRate;
  const achievement = ((totalCompleted / totalTarget) * 100).toFixed(0);
  const { openSidebar } = useOutletContext();

  return (
<div className="rp-commission-dashboard">
  <ProfileHeader onMenuClick={openSidebar} val="Commission Dashboard" />

  <div className="rp-commission-kpi-grid">
    <div className="rp-commission-card">
      <h3>{totalTarget}</h3>
      <p>Target Leads</p>
    </div>

    <div className="rp-commission-card">
      <h3>{totalCompleted}</h3>
      <p>Completed Leads</p>
    </div>

    <div className="rp-commission-card">
      <h3>{achievement}%</h3>
      <p>Achievement</p>
    </div>

    <div className="rp-commission-card">
      <h3>₹{estimatedCommission}</h3>
      <p>Estimated Commission</p>
    </div>

    <div className="rp-commission-card">
      <h3>15 March</h3>
      <p>Next Payout</p>
    </div>
  </div>

  <div className="rp-commission-chart">
    <h3>Monthly Performance</h3>
    <ResponsiveContainer width="100%" height={300}>
      <BarChart data={data}>
        <CartesianGrid strokeDasharray="3 3" />
        <XAxis dataKey="month" />
        <YAxis />
        <Tooltip />
        <Legend />
        <Bar
          dataKey="completed"
          fill="rgba(33, 192, 152, 0.3)"
          name="Completed Leads"
        />
        <Line
          type="monotone"
          dataKey="commission"
          stroke="#21c098"
          strokeWidth={3}
          name="Commission"
        />
      </BarChart>
    </ResponsiveContainer>
  </div>

  <div className="rp-commission-timeline">
    <h3>Payout Cycle (45 Days)</h3>
  </div>

  <div className="rp-commission-table-wrapper">
    <h3>Monthly Commission Details</h3>
    <div className="rp-commission-table-scroll">
      <table className="rp-commission-table">
        <thead>
          <tr>
            <th>Month</th>
            <th>Target</th>
            <th>Completed</th>
            <th>Achievement</th>
            <th>Commission</th>
            <th>Payout Date</th>
            <th>Status</th>
          </tr>
        </thead>
        <tbody>
          {data.map((item, index) => (
            <tr key={index}>
              <td>{item.month}</td>
              <td>{item.target}</td>
              <td>{item.completed}</td>
              <td>
                {((item.completed / item.target) * 100).toFixed(0)}%
              </td>
              <td>₹{item.commission}</td>
              <td>15 {item.month}</td>
              <td>
                <span className="rp-commission-badge rp-commission-badge-paid">
                  Paid
                </span>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  </div>
</div>

  );
};

export default Commission;
